import { getFileNameFromPath, bytesToMb } from '../../js/shared/utils.js';

(function() {

    if (!document.querySelector('.form-upload')) {
        return;
    }

    const clearUpload = (formUpload) => {
        const uploadControl = formUpload.querySelector('.form-upload-control__input');

        formUpload.classList.remove('is-selected');
        uploadControl.value = '';
    }

    const setDefaultMessage = (formUpload) => {
        const messagePlace = formUpload.querySelector('.form-upload-message');
        const message = messagePlace.getAttribute('data-default');

        messagePlace.classList.remove('is-error');
        messagePlace.innerText = message;
    }

    const setError = (formUpload, message) => {
        const messagePlace = formUpload.querySelector('.form-upload-message');
        messagePlace.classList.add('is-error');
        messagePlace.innerText = message;
    }

    document.addEventListener('change', e => {
        const target = e.target;
        if (target.closest('.form-upload-control__input')) {
            const formUpload = target.closest('.form-upload');
            const filePath = target.value;
            const selectedTitlePlace = formUpload.querySelector('.form-upload-selected__title');

            if (filePath) {

                // проверяем допустимый размер
                const fileSize = bytesToMb(target.files[0].size);
                const maxSize = parseFloat(target.getAttribute('data-maxsize'));

                // файл больше, чем возможно
                if (maxSize && (fileSize > maxSize)) {
                    clearUpload(formUpload);
                    setError(formUpload, `Файл превышает максимальный размер ${maxSize} мб`);
                }
                // всё ок, добавляем файл
                else {
                    formUpload.classList.add('is-selected');
                    selectedTitlePlace.innerText = getFileNameFromPath(filePath);
                    setDefaultMessage(formUpload);
                }
            } else {
                formUpload.classList.remove('is-selected');
            }
        }
    });

    document.addEventListener('click', e => {
        const target = e.target;
        if (target.closest('.form-upload-selected')) {
            const formUpload = target.closest('.form-upload');
            clearUpload(formUpload);
        }
    })

}())